import { v4 } from 'uuid';

export const dataPrivacyList = [
  {
    heading: 'Contact Details',
    categories: [
      {
        id: v4(),
        text: 'Name (full or partial)',
      },
      {
        id: v4(),
        text: 'Gender',
      },
      {
        id: v4(),
        text: 'Phone number',
      },
      {
        id: v4(),
        text: 'Address (full or partial)',
      },
      {
        id: v4(),
        text: 'Email address',
      },
      {
        id: v4(),
        text: 'Date of birth',
      },
    ],
  },
  {
    heading: 'Demographic',
    categories: [
      {
        id: v4(),
        text: 'LGBTI status',
        info: 'Incl. sexual attraction, orientation or practices',
      },
      {
        id: v4(),
        text: 'Race or ethnic origin',
        info: 'Incl. cultural background',
      },
      {
        id: v4(),
        text: 'Religion',
        info: 'Incl. beliefs or affiliations',
      },
      {
        id: v4(),
        text: 'Nationality',
      },
      {
        id: v4(),
        text: 'Marital status',
      },
      {
        id: v4(),
        text: 'Political',
        info: 'Incl. association or opinions',
      },
      {
        id: v4(),
        text: 'Associations or memberships',
        info: 'Incl. profession, trade union, other',
      },
      {
        id: v4(),
        text: 'Vulnerable persons status',
        info: 'E.g. children or persons lacking mental capacity',
      },
      {
        id: v4(),
        text: 'Citizenship / visa information',
      },
    ],
  },
  {
    heading: 'Education, Business and basic job',
    categories: [
      {
        id: v4(),
        text: 'Qualifications',
      },
      {
        id: v4(),
        text: 'CV / resume',
      },
      {
        id: v4(),
        text: 'References',
      },
      {
        id: v4(),
        text: 'Employee performance / goals',
      },
      {
        id: v4(),
        text: 'Job history',
      },
      {
        id: v4(),
        text: 'Employment disputes',
      },
      {
        id: v4(),
        text: 'Psychological data',
        info: 'Personality, character',
      },
    ],
  },
  {
    heading: 'Financial',
    categories: [
      {
        id: v4(),
        text: 'Bank / credit / debit card details',
      },
      {
        id: v4(),
        text: 'Employment superannuation or equivalent',
      },
      {
        id: v4(),
        text: 'Credit reporting information',
      },
      {
        id: v4(),
        text: 'Salary / wage',
      },
      {
        id: v4(),
        text: 'Employment benefits/incentives',
      },
    ],
  },
  {
    heading: 'Health',
    categories: [
      {
        id: v4(),
        text: 'Medical records',
        info: 'Incl. medical history, x-rays and scans',
      },
      {
        id: v4(),
        text: 'Medical reports and opinions',
      },
      {
        id: v4(),
        text: 'Medicare history or equivalent',
      },
      {
        id: v4(),
        text: 'Health services',
        info: 'E.g. psychology, physio',
      },
      {
        id: v4(),
        text: 'Biometric information',
        info: 'E.g. body measurements or fingerprint data',
      },
      {
        id: v4(),
        text: 'Fitness data',
        info: 'E.g. steps per day, calories burned, heartrate',
      },
      {
        id: v4(),
        text: 'Mental health information ',
      },
    ],
  },
  {
    heading: 'Identifiers Government',
    categories: [
      {
        id: v4(),
        text: 'Medicare or equivalent number',
      },
      {
        id: v4(),
        text: 'Centrelink, job centre or equivalent number',
      },
      {
        id: v4(),
        text: 'Tax file or equivalent number',
      },
    ],
  },
  {
    heading: 'Identifiers Personal',
    categories: [
      {
        id: v4(),
        text: 'Passport information or number',
      },
      {
        id: v4(),
        text: 'Drivers licence information or number',
      },
      {
        id: v4(),
        text: 'Photo / image',
      },
      {
        id: v4(),
        text: 'Professional licence or membership number',
        info: 'E.g. taxi / medical council',
      },
      {
        id: v4(),
        text: 'Birth certificate',
      },
      {
        id: v4(),
        text: 'Marriage certificate',
      },
    ],
  },
  {
    heading: 'Police or criminal record',
    categories: [
      {
        id: v4(),
        text: 'Convictions, proceedings, history or records',
      },
      {
        id: v4(),
        text: 'Criminal allegations',
      },
    ],
  },
  {
    heading: 'Policyholder and Claimant',
    categories: [
      {
        id: v4(),
        text: 'Claim and/or policy number',
      },
      {
        id: v4(),
        text: 'Vehicle registration number',
      },
    ],
  },
  {
    heading: 'Social, Media, Technology',
    categories: [
      {
        id: v4(),
        text: 'Social media profile',
        info: 'Incl. photos, bio, post history',
      },
      {
        id: v4(),
        text: 'Location data',
        info: 'E.g. GPS, geolocation',
      },
      {
        id: v4(),
        text: 'SMS or text messages',
        info: 'Incl. WhatsApp, Facebook Messenger',
      },
      {
        id: v4(),
        text: 'Tracking technology',
        info: 'E.g. cookies data',
      },
    ],
  },
];
